const BLUETOOTH_HEART_RATE_SOURCES = new Set([
  "garmin-band",
  "garmin-watch",
  "wear-os",
  "bluetooth",
]);

export const shouldAcceptIOSHeartRateStatus = (detail = {}, preferredSource = "auto") => {
  const transport = String(detail?.transport || "").toLowerCase();
  if (!transport || preferredSource === "auto") return true;
  if (BLUETOOTH_HEART_RATE_SOURCES.has(preferredSource)) return transport === "bluetooth";
  if (["airpods", "apple-watch"].includes(preferredSource)) return transport === "healthkit";
  return true;
};

